import { UserManager, WebStorageStateStore, User } from 'oidc-client';
import config from '../../config.js'
import i18n from "@/i18n";
export default class AuthService {
    private userManager: UserManager;

    constructor() {
        const STS_DOMAIN = config.AUTH_URL;
        const settings: any = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: STS_DOMAIN,
            client_id: config.AUTH_CLIENT_ID,
            client_secret: config.AUTH_CLIENT_SECRET,
            redirect_uri: config.BASE_URL + 'callback.html',
            automaticSilentRenew: false,
            response_type: 'code',
            scope: 'openid',
            post_logout_redirect_uri: config.BASE_URL,
            filterProtocolClaims: true,
            extraQueryParams: {
                lang: i18n.locale
            }
        };
        this.userManager = new UserManager(settings);
    }

    public getUser(): Promise<User> {
        return this.userManager.getUser();
    }

    public login(): Promise<void> {
        localStorage.setItem('lang', i18n.locale);
        return this.userManager.signinRedirect();
    }

    public logout(): Promise<void> {
        return this.userManager.signoutRedirect();
    }

    public updateLanguage(): void {
        const lang = i18n.locale;
        this.userManager.settings.extraQueryParams = { lang };
    }

    public getAccessToken(): Promise<string> {
        return this.userManager.getUser().then((data: any) => {
            return data.access_token;
        });
    }
}
